import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { CandidateResume } from 'wisestep-api';
import {
  FileTypeVariants,
  WsButton,
  WsColors,
  WsDialog,
  WsFileUpload,
  WsRadioGroup,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { failed } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

const selectArray = [
  { label: 'CV', value: 'CV' },
  { label: 'other documents', value: 'OTHER' },
];

const UploadDialog = ({
  name,
  open,
  handleClose,
  uploadFile,
  document,
  saveAction,
  removeDocument,
  disableSelectCatagory,
}: {
  name: string;
  open: boolean;
  handleClose: () => void;
  uploadFile: (files: File[]) => void;
  document: CandidateResume;
  saveAction: () => void;
  removeDocument: () => void;
  disableSelectCatagory: boolean;
}) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const { watch } = useFormContext();
  const documentType = watch(name) ?? 'CV';

  const onFileRejected = (fileRejections) => {
    const firstRejection = fileRejections?.[0];
    const reason = firstRejection?.errors?.[0]?.code;
    if (reason === 'file-too-large') {
      setNotification(failed('File size exceeds 10 MB limit'));
    } else if (reason === 'file-invalid-type') {
      setNotification(failed('Invalid file type. Please upload a supported document or image.'));
    } else {
      setNotification(failed('File upload failed. Please try again.'));
    }
  };

  return (
    <WsDialog openDialog={open} size="large">
      <DialogTitle sx={{ background: WsColors.TertiaryShades50 }}>
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
              Upload File
            </WsTypography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose} sx={{ padding: 0 }}>
              <CloseIcon sx={{ fill: WsColors.GreyBlack, cursor: 'pointer' }} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers sx={{ px: 3 }}>
        <Grid container direction="column" rowSpacing={1}>
          {!disableSelectCatagory && (
            <Grid item>
              <Grid item>
                <WsTypography variant={WsTypoVariants.BODY1}>Select file catagory</WsTypography>
              </Grid>
              <Grid item>
                <WsRadioGroup name={name} selectArray={selectArray} />
              </Grid>
            </Grid>
          )}
          <Grid item height={300}>
            <WsFileUpload
              multiple={false}
              onUpload={(file: File[]) => uploadFile(file)}
              name={'document'}
              placeholderText="Drag & drop .pdf or .docx file "
              buttonText={'Upload File'}
              maxFileSize={10}
              fileTypes={
                documentType !== 'CV' ? FileTypeVariants.DOCS_AND_IMAGES : FileTypeVariants.RESUME
              }
              onFileRejected={onFileRejected}
            />
          </Grid>
          {document?.resumeFileName && (
            <Grid item container columnSpacing={1} alignItems="center">
              <Grid item>
                <WsTypography variant={WsTypoVariants.BODY1}>
                  {document?.resumeFileName}
                </WsTypography>
              </Grid>
              <Grid item>
                <IconButton onClick={removeDocument} sx={{ padding: 0 }}>
                  <CloseIcon sx={{ color: WsColors.Red500, cursor: 'pointer', fontSize: 16 }} />
                </IconButton>
              </Grid>
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 1 }}>
        <WsButton type="submit" onClick={saveAction}>
          Save
        </WsButton>
      </DialogActions>
    </WsDialog>
  );
};
export default UploadDialog;
